import makeApiRequest from './makeApiRequest';

export default async function setGDPR(account, instance) {
    return await makeApiRequest(account, instance, 'put', 'SetGDPRAuth');
}